module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAM1BMVEUAAABhokJio0Jgn0hhokNhokNgn0BiokJhokJiokNhoUJhoUNhpkVjn0Nkn0Bgn0BiokN/+2zRAAAAEHRSTlMA318g738gn4+/z78/UEAQQsFqfwAAAIVJREFUKM+FkUkOxDAIBGmvcTJL//+1E8eHkQ0kJQ6gkrAay0oExCaCkwJy/JsyKZItfJXpvGoiU33PBnSA0EXOMhkK9rZe3jZz56IC0MPXj1IgMaJAKYQRHtALwyjjLTJeZajGi91QZefReBSl3Fyaxxv6l3e5++WT3Lutd3raUsoi6/QDQ7oUm59vEtwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aiInterviewAllPro/Vector.png
// module id = tgVG
// module chunks = 21